import { render, staticRenderFns } from "./ModalTransferida.vue?vue&type=template&id=4c792985"
import script from "./ModalTransferida.vue?vue&type=script&lang=js"
export * from "./ModalTransferida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports